import { render, staticRenderFns } from "./NewbieGuide.vue?vue&type=template&id=6e19da9b&scoped=true"
import script from "./NewbieGuide.vue?vue&type=script&lang=js"
export * from "./NewbieGuide.vue?vue&type=script&lang=js"
import style0 from "./NewbieGuide.vue?vue&type=style&index=0&id=6e19da9b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e19da9b",
  null
  
)

export default component.exports